<mat-form-field class="location-node-picker" appearance="outline">
    <mat-label>{{ label }}</mat-label>
    <mat-select
        [value]="value"
        [disabled]="disabled"
        [required]="required"
        [placeholder]="placeholder"
        (selectionChange)="selectionChanged($event.value)">
        <mat-select-trigger>
            <span *ngIf="selectedNode as selected" class="location-node-picker__option location-node-picker__option--selected">
                <span class="location-node-picker__type">{{ typeLabel(selected.type) }}</span>
                <span class="location-node-picker__name">{{ selected.name }}</span>
            </span>
        </mat-select-trigger>
        <mat-option *ngIf="allowClear && !required" [value]="null">No parent</mat-option>
        <mat-option *ngFor="let node of nodes" [value]="node.id">
            <span class="location-node-picker__option" [style.padding-left.px]="optionIndent(node)">
                <span class="location-node-picker__type">{{ typeLabel(node.type) }}</span>
                <span class="location-node-picker__name">{{ node.name }}</span>
            </span>
        </mat-option>
    </mat-select>
    <mat-progress-spinner
        *ngIf="loading"
        matSuffix
        diameter="18"
        mode="indeterminate"></mat-progress-spinner>
</mat-form-field>
